import React, { FC } from 'react';
import { BasicContainer, BodyText, FlexCol, FlexDynamic, FlexRow, H3Text, XlText } from '@minecraft.atoms';
import Icon from '@minecraft.icon';
import { Trans, useTranslation } from '@blocs.i18n';
import { WindowWidthContext } from '@minecraft.utils';
import { TestimonialCard } from './TestimonialCard';

export const RegistrationUpsell: FC<{ isRegistration?: boolean }> = React.memo(({ isRegistration }) => {
  const { t } = useTranslation();
  const isMobile = WindowWidthContext.useIsMobile();

  if (!isRegistration) return null;

  return (
    <FlexDynamic
      direction="column"
      gap="8"
      mdProps={{ direction: 'row', gap: '4' }}
      wrap="nowrap"
      justifyContent="flex-start"
      className="cn_mb-1"
    >
      <FlexDynamic
        direction="column"
        gap="0"
        mdProps={{ direction: 'row', gap: '3' }}
        wrap="nowrap"
        justifyContent="flex-start cn_mb-4"
      >
        {isMobile ? (
          <BasicContainer className="cn_w-full">
            <FlexRow alignItems="center" gap="1" className="cn_mb-3">
              <Icon
                name="membership-illustrations"
                className="cn_atom_w-12 cn_atom_h-12 cn_atom-w-1/2"
                width={8}
                height={5}
              />
              <H3Text fontWeight="medium" lineHeight="default">
                <Trans i18nKey="common:paywall.registrationUpsell.scheduleActingAuditions" components={[<br />]} />
              </H3Text>
            </FlexRow>
            <BodyText>{t('common:paywall.registrationUpsell.castingSoftware')}</BodyText>
          </BasicContainer>
        ) : (
          <>
            <Icon name="membership-illustrations" className="cn_atom_w-12 cn_atom_h-12" />
            <FlexCol
              gap="2"
              className="cn_ml-4 cn_w-full cn_max-w-md"
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <XlText as="h3" lineHeight="condensed">
                <Trans i18nKey="common:paywall.registrationUpsell.scheduleActingAuditions" components={[<br />]} />
              </XlText>
              <BodyText>{t('common:paywall.registrationUpsell.castingSoftware')}</BodyText>
            </FlexCol>
          </>
        )}
      </FlexDynamic>
      <TestimonialCard />
    </FlexDynamic>
  );
});
